import React from 'react'
import { useField } from 'formik'
import { withStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'
import Switchs from 'app/componentV4/Switchs'
import useFeatureFlag from 'app/configs/useFeatureFlag'

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 34,
    height: 18,
    padding: 0,
  },
  rootDisbled: {
    width: 34,
    height: 18,
    padding: 0,
    opacity: '0.5 !important',
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
    '&.MuiSwitch-switchBase': {
      padding: '2px !important',
    },
  },
  thumb: {
    width: 14,
    height: 14,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: '#cccccc',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  const { mes_3832_new_design_compose_message } = useFeatureFlag()
  return mes_3832_new_design_compose_message ? (
    <Switchs {...props} />
  ) : (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: props.disabled ? classes.rootDisbled : classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  )
})

const IosSwitchFormik = (props) => {
  const [field, meta, helpers] = useField(props.name)
  const { value } = meta
  const { setValue } = helpers

  return (
    <>
      <IOSSwitch
        {...field}
        checked={value || false}
        disabled={props.disabled || false}
        onChange={(event) => {
          setValue(event.currentTarget.checked)
          if (props.onChange) {
            props.onChange(event.currentTarget.checked)
          }
        }}
      />
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </>
  )
}

export default IosSwitchFormik
